export default __webpack_public_path__ + "static/media/view-cliente-venta.cc8a08ad.svg";